export type MockStore<TOptions, TResponse> = Map<
  string,
  Map<string, (options: TOptions) => TResponse>
>;

export const unmockedGraphQlOperationsStore: Set<string> = new Set();
